import CustomizeIcon from '@atlaskit/icon/core/customize';
import React from 'react';

export const SvgTune = () => (
  <CustomizeIcon label="" testId="ads-refreshed-icon" />
);
